//资金记录tab枚举
export enum CompletedOrderOrderProcessEnum {
  //充值
  ADD = '1',
  //提现
  SUB = '2',
  //资金记录
  ALL = '3',
  //闪兑
  SWAP = '4',
  //划转
  TRANSFER = '5',
}
// 动态表单编码枚举
export enum DynamicFormEncodingEnumeration {
  // 实名认证
  REAL_NAME_AUTHENTICATION =  'REAL_NAME_AUTHENTICATION'
}
/**
 *
 *  username  用户账户（手机号/邮箱号）
 captcha  验证码
 password  密码
 invitationCode  邀请码
 */

export enum WAY_TO_REGISTER {
  // 手机号注册
  PHONE = '0',
  // 邮箱注册
  EMAIL = '1',
}
// 动态表单类型
export enum DynamicFormType {
  // 单行文本
  Input = 1,
  // 多行文本
  Textarea = 2,
  // 数值类型
  Number = 3,
  // 布尔类型
  Boolean = 5,
  // 附件类型
  Attachment = 7,
  // 下拉框
  Select = 8,
  // 特殊接口下拉（需请求接口）
  SpecialSelect = 9,
}
export enum VerifiedStatesEnum {
  //未实名
  UNREAL = 0,
  //审核中
  UNDER = 1,
  //已实名
  REAL = 2,
  // 拒绝
  PASS= -1
}

/**
 * 资金记录-沙特账户/美股账户筛选
 **/
export enum FundsRecordAccountTypesOnlyEnum {
  /**
   * 沙特账户
   **/
  SAR_ACCOUNT = '0',
  /**
   * 美股账户
   **/
  USD_ACCOUNT = '1',
}

/**
 * 当前账户类型
 **/
export enum CurrentAccountTypeEnum {
  /**
   * 真实用户
   **/
  REAL_USER = 2,
  /**
   * 匿名用户
   **/
  ANONYMOUS_USER = 1,
}

/**
 * 发送验证码类型（手机号，邮箱）
 **/
export enum VerifiedCodeTypeEnum {
  // 手机号
  PHONE = 1,
  // 邮箱
  EMAIL = 2,
}

/**
 * 发送验证码用途
 **/
export enum VerifiedCodeEnum {
  // 注册验证码
  REGISTER = 1,
  // 重置密码
  RESET_PASSWORD = 2,
  // 更新资料
  UPDATE_PROFILE = 3,
}


//买入卖出状态
export enum CompletedOrderOrderTypeEnum {
  //买入
  BUY = '0',
  //卖出
  SELL = '1',
}

// 大宗类型
export enum BulkTypeEnum {
  //跟单交易
  COPY_TRADING = 'COPY_TRADING',
  //库存股
  TREASURY_STOCK = 'TREASURY_STOCK'
}

//审核中和已完成
export enum CompletedOrderOrderStatusEnum {
  //审核中
  UnderReview = '0',
  //未通过
  DID_NOT_PASS = '-1',
  //已完成
  COMPLETED = '1',
  // 等待审核中
  WAITING_FOR_REVIEW = '2',
}

//订单来源枚举
export enum FundsOrderHistorySourceEnum {
  /**
   * 直接购买
   **/
  DIRECT_PURCHASE = 1,
  /**
   * 申购
   **/
  SUBSCRIPTION = 2,
  /**
   * 大宗
   **/
  BULK = 3,
}

// 合约来源
export enum ContractSourceEnum {
  //IEO
  IEO = '4',
  //配售
  PLACING = '5',
}

//资金记录
export enum FundsOrderHistoryEnum {
  // ============================公共 ============================

  /**
   * 闪兑
   * */
  ORDER_FLASH_EXCHANGE = 26,
  /**
   * 赠送
   * */
  GIVE_AWAY = 0,
  /**
   * 管理端充值
   * */
  ADMIN_RECHARGE = 1,
  /**
   * 管理端扣除
   * */
  ADMIN_DEDUCT = 2,
  /**
   * 管理端提现
   * */
  ADMIN_WITHDRAWAL = 8,
  /**
   * VIP购买
   * */
  VIP_PURCHASE = 400,
  /**
   *  VIP升级退回
   * */
  VIP_PURCHASE_REFUND = 401,
  /**
   *  邀请返佣
   * */
  INVITATION_REBATE = 500,
  /**
   *  邀请返现
   * */
  INVITATION_REBATE_CASH = 501,

  /**
   * 划转
   * */
  CONTRACT_TRANSFER = 3,
  // ============================股票账户 ============================
  /**
   *  股票订单交易
   */
  ORDER_STOCK = 11,
  /**
   * 贷款
   */
  LOAN = 502,
  /**
   * 贷款还款
   */
  LOAN_DEAL_REPAYMENT = 503,
  /**
   * 分销返佣
   */
  DISTRIBUTION_REBATE = 504,
  /**
   * 分销返现
   */
  DISTRIBUTION_REBATE_CASH = 505,
  /**
   * 申购购买
   */
  SUBSCRIPTION_PURCHASE = 13,

  /**
   * 大宗交易
   */
  BULK_TRADE = 14,
  /**
   * 股票交易-平仓手续费
   **/
  STOCK_CLOSING_FEE = 200,
  /**
   * 股票交易-市价购买
   **/
  STOCK_MARKET_BUY = 201,
  /**
   * 股票交易赠送
   **/
  STOCK_TRADING_GIFTS = 211,
  /**
   * 股票交易-委托购买
   **/
  STOCK_ENTRUST_BUY = 202,
  /**
   * 股票交易-委托成功
   **/
  STOCK_ENTRUST_SUCCESS = 203,
  /**
   * 股票交易-取消委托
   **/
  STOCK_CANCEL = 204,
  /**
   * 股票交易-平仓结算
   **/
  STOCK_CLOSING_SETTLEMENT = 205,
  /**
   * 股票交易-平仓扣除
   **/
  STOCK_CLOSING_DEDUCTION = 206,
  /**
   * 股票交易-爆仓扣除
   **/
  STOCK_BURST_DEDUCTION = 207,
  /**
   * 股票账户提现
   */
  STOCK_WITHDRAWAL = 100,
  /**
   * 提现失败，退回到股票账户
   */
  STOCK_WITHDRAWAL_FAIL = 101,
  /**
   * 充值到股票账户
   */
  RECHARGE_STOCK_ACCOUNT = 102,
  /**
   * 申购购买
   */
  SUBSCRIPTION_BUY = 700,
  /**
   * 申购IPO购买
   */
  SUBSCRIPTION_IPO_BUY = 701,
  /**
   * 申购IEO购买
   */
  SUBSCRIPTION_IEO_BUY = 710,
  /**
   * 申购IEO补缴
   */
  SUBSCRIPTION_IEO_BUY_PAY_BACK = 711,
  /**
   * 申购IEO退款
   */
  SUBSCRIPTION_IEO_REIMBURSE = 712,
  /**
   * 申购配售购买
   */
  SUBSCRIPTION_RATION_BUY = 720,
  /**
   * 申购配售购买-补缴
   */
  SUBSCRIPTION_RATION_BUY_PAY_BACK = 721,
  /**
   * 申购配售退款
   */
  SUBSCRIPTION_RATION_REIMBURSE = 723,
  // ============================币币账户 ============================
  /**
   * 币币订单交易 限价
   * */
  CONTRACT_ORDER_TRADE_PRICE_LIMIT = 24,
  /**
   * 币币订单交易 市价
   * */
  CONTRACT_ORDER_TRADE = 4,
  /**
   * ai
   **/
  AI_ORDER_TRADE = 12,
  /**
   * 币币提现
   */
  FUND_WITHDRAWAL = 103,
  /**
   * 币币账户提现失败
   */
  FUND_WITHDRAWAL_FAIL = 104,
  /**
   * 币币账户充值
   */
  RECHARGE_FUND_ACCOUNT = 105,
  // ============================合约 ============================
  /**
   * 合约交易-平仓手续费
   **/
  CONTRACT_CLOSING_FEE = 300,
  /**
   * 合约交易-市价购买
   **/
  CONTRACT_MARKET_BUY = 301,
  /**
   * 合约交易-限价购买
   **/
  CONTRACT_LIMIT_BUY = 302,
  /**
   * 合约交易-取消委托
   **/
  CONTRACT_REVOKE = 303,
  /**
   * 合约交易-平仓结算
   **/
  CONTRACT_CLOSING_SETTLEMENT = 304,
  /**
   * 合约交易-平仓扣除
   **/
  CONTR = 305,
  /**
   * CONTRACT_FORCED_LIQUIDATION 合约交易-全仓强平
   */
  CONTRACT_FORCED_LIQUIDATION = 306,
  /**
   * CONTRACT_ISOLATED_FORCED_LIQUIDATION 合约交易-逐仓强平
   */
  CONTRACT_ISOLATED_FORCED_LIQUIDATION = 307,
  /**
   * CONTRACT_LIMIT 合约交易-限价
   */
  CONTRACT_LIMIT = 308,
  /**
   * CONTRACT_STOP_PROFIT_LOSS 合约交易-止盈止损
   */
  CONTRACT_STOP_PROFIT_LOSS = 309,
  /**
   * CONTRACT_LEAD_TRADING 合约交易-跟单订单完成
   */
  CONTRACT_LEAD_TRADING = 310,
  /**
   * CONTRACT_LEAD_TRADING_COMPLETE 合约交易-跟单订单平仓
   */
  CONTRACT_LEAD_TRADING_COMPLETE = 311,
  /**
   * 合约账户提现
   */
  CONTRACT_WITHDRAWAL = 106,
  /**
   * 合约账户提现失败
   */
  CONTRACT_WITHDRAWAL_FAIL = 107,
  /**
   * 合约账户充值
   */
  RECHARGE_CONTRACT_ACCOUNT = 108,
  // ============================基金类型  ============================
  /**
   * 基金购买
   */
  SUBSCRIPTION_FUND_BUY = 803,
  /**
   * 基金账户提现
   */
  TRUST_WITHDRAWAL = 109,
  /**
   * 基金账户提现失败
   */
  TRUST_WITHDRAWAL_FAIL = 110,
  /**
   * 基金账户充值
   */
  RECHARGE_TRUST_ACCOUNT = 111,
  /**
   * 基金赎回
   */
  SUBSCRIPTION_FUND_REDEEM = 804,
  /**
   * 基金分红提取
   */
  SUBSCRIPTION_FUND_DIVIDEND = 805,
}

//获取文本枚举
export enum GetTextEnum {
  /**
   * 隐私条款类型编码
   */
  PRIVACY_CLAUSE_CODE = 'SYSTEM_PRIVACY_CLAUSE',
  /**
   * 实名认证类型编码
   */
  SYSTEM_REAL_NAME = 'SYSTEM_REAL_NAME',
  /**
   * 开户协议
   */
  ACCOUNT_OPENING_AGREEMENT = 'ACCOUNT_OPENING_AGREEMENT',
  /**
   * 保密协议
   */
  CONFIDENTIALITY_AGREEMENT = 'CONFIDENTIALITY_AGREEMENT',
  /**
   * app 贷款协议
   */
  APP_LOAN_AGREEMENT = 'APP_LOAN_AGREEMENT',
  /**
   * 用户协议类型编码
   */
  SYSTEM_USER = 'SYSTEM_USER',
  /**
   * 关于我们类型编码
   */
  APP_ABOUT_US = 'APP_ABOUT_US',
  /**
   * 公司简介编码
   */
  COMPANY_INTRODUCTION = 'COMPANY_INTRODUCTION',
  /**
   * 返佣规则
   */
  SYSTEM_REBATE_RULES = 'SYSTEM_REBATE_RULES',
  /**
   * 日内交易规则
   */
  DAY_TRADING_RULES = 'DAY_TRADING_RULES',
  /**
   * ETF交易规则
   */
  ETF_RULES = 'ETF_RULES',
  /**
   * 定期-理财时间线
   */
  FINANCIAL_TIMELINE = 'FINANCIAL_TIMELINE',
  // "量化-收益规则"
  QUANTITATIVE_EARNINGS_RULES = 'QUANTITATIVE_EARNINGS_RULES',
  // "量化-服务协定"
  QUANTITATIVE_SERVICE_CONTRACT = 'QUANTITATIVE_SERVICE_CONTRACT',
  // "量化-理财时间线"
  QUANTITATIVE_FINANCIAL_TIMELINE = 'QUANTITATIVE_FINANCIAL_TIMELINE',
  // 量化收益规则
  SYSTEM_AI_EARNINGS_RULES = 'SYSTEM_AI_EARNINGS_RULES',
  // 量化服务协议
  SYSTEM_SERVICE_AGREEMENT = 'SYSTEM_SERVICE_AGREEMENT',
  /**
   * 定期-服务协定
   */
  SERVICE_CONTRACT = 'SERVICE_CONTRACT',
  /**
   * 定期-收益规则
   */
  EARNINGS_RULES = 'EARNINGS_RULES',
  // VIP权益
  VIP_RIGHTS = 'VIP_RIGHTS',

}
// 理财列表
export enum FINANCIAL_MANAGEMENT_LIST_ENUM {
  // AI交易
  QUANTIFICATION_FINANCIAL_MANAGEMENT = '0',
  // 定期理财
  REGULAR_FINANCIAL_MANAGEMENT = '1',
}
//IM消息状态
export enum ImMessageStatusEnum {
  /**
   * 正常消息 1
   **/
  NORMAL_MESSAGE = 1,
  /**
   * 编辑消息 2
   **/
  EDIT_MESSAGE = 2,
  /**
   * 撤回消息 -1
   **/
  WITHDRAW_MESSAGE = -1,
}

//IM发送消息状态
export enum SEND_MESSAGE_STATUS {
  /**
   * 失败发送
   **/
  FAIL = -1,
  /**
   * 等待中
   **/
  WAIT = 2,
  /**
   * 成功发送
   **/
  SUCCEED = 3,
}

//IM消息类型
export enum ImMessageTypeEnum {
  /**
   * 文字
   **/
  TEXT = 'TEXT',
  /**
   * 图片
   **/
  IMAGE = 'IMAGE',
  /**
   * 订单
   **/
  ORDER = 'ORDER',
  /**
   * 订单
   **/
  VIDEO = 'VIDEO',
  /**
   * 加入工单
   **/
  JOIN_MESSAGES = 'JOIN_MESSAGES',
  /**
   * 结束工单
   **/
  FINISH_MESSAGES = 'FINISH_MESSAGES',
}

// 资金记录类型枚举
export enum ConfuseCompletedOrderOrderTypeEnum {
  //
  CONFUSE = 'CONFUSE',
  //充值
  ADD = 'ADD',
  //提现
  SUB = 'SUB',
  //闪兑
  SWAP = 'SWAP',
  //划转
  TRANSFER = 'TRANSFER',
}
//资金记录来源分类
export enum FundsSourceEnum {
  /**
   * 账户操作
   *
   * */
  ACCOUNT_OPERATION = 1,
  /**
   * 股票
   *
   * */
  STOCK_OPERATION = 2,
  /**
   * 合约
   *
   * */
  CONTRACT_OPERATION = 3,
  /**
   * 现货
   *
   * */
  BINANCE_OPERATION = 4,
  /**
   * 申购
   *
   * */
  SUBSCRIPTION = 5,
  /**
   * 基金
   *
   * */
  FUND_OPERATION = 6,
  /**
   * 邀请
   *
   * */
  SYSTEM_INVITATION = 7,
}

//文本类型--区分富文本和markdown
export enum TextTypeEnum {
  /**
   * markdown
   **/
  MARKDOWN = 1,
  /**
   * 富文本
   **/
  RICH_TEXT = 2,
}

// 交易类型 限价/市价
export enum TradeTypeEnum {
  /**
   * 市价
   **/
  MARKET = 1,
  /**
   * 限价
   **/
  LIMIT = 2,
}

//保证金模式 全仓/逐仓
export enum MarginModeEnum {
  /**
   * 全仓
   **/
  FULL = 1,
  /**
   * 逐仓
   **/
  SEGMENTED = 2,
}

//保证金模式 做多/做空
export enum TradingDirectionEnum {
  //做多
  LONG = 1,
  //做空
  SHORT = 2,
}

/**
 * 收藏枚举
 **/
export enum CollectEnum {
  /**
   * 币币收藏
   **/
  COIN_COLLECT = 1,
  /**
   * 合约收藏
   **/
  CONTRACT_COLLECT = 2,
  /**
   * 股票收藏
   **/
  STOCK_COLLECT = 3,
}

/**
 * 市场列表或者订单列表
 **/
export enum GetCoinListTypeEnum {
  /**
   * 币币
   **/
  COIN = '1',
  /**
   * 合约
   **/
  CONTRACT = '2',
  /**
   * 股票
   **/
  STOCK = '3',
  /**
   * 收藏
   **/
  COLLECT = '4',
  /**
   * 快速 合约
   **/
  FASTCONTRACT = '5',
  /**
   * 外汇 合约
   **/
  FOREIGN_EXCHANGE = '6',
  /**
   * 期货
   **/
  CONTRACT_FUTURES = '8',

  /**
   * 基金
   **/
  FUND = '20',
  /**
   * ipo
   */
  IPO = '21',
  /**
   * IEO
   */
  IEO = '22',
  /**
   * AI
   */
  AI = '23',

}
// 定义交易类型的枚举
export enum TransactionTypeEnum {
  // 限价交易
  LIMIT = 2,
  // 市价交易
  MARKET = 1,
  // 止盈止损
  STOP_LOSS = 3,
}

/**
 * 合约下的列表类型
 **/
export enum ContractListTypeEnum {
  /**
   * 外汇
   **/
  FOREIGN_EXCHANGE = '2',
  /**
   * 加密货币
   **/
  CRYPTOCURRENCY = '1',
}

/**
 * 股票的列表类型
 **/
export enum StockListTypeEnum {
  /**
   * 普通股票
   **/
  COMMON_STOCK = '1',
  /**
   * 申购股票
   **/
  IPO = '2',
  /**
   * 大宗股票
   **/
  BULK_STOCKS = '3',
  /**
   * IEO
   **/
  IEO = '6',
  /**
   * 配售
   **/
  DISTRIBUTION = '7',
}

/**
 * 股票类别
 */
export enum StockTypeEnum {
  /**
   * 三方股票
   **/
  THIRD_PARTY_STOCKS = '1',
  /**
   * 美国股票
   **/
  US_STOCKS = '2',
  /**
   * UC股票
   **/
  UC_STOCKS = '3',
}

/**
 * 获取币种类型
 **/
export enum CoinTypeEnum {
  /**
   * 马来西亚股票
   **/
  MALAYSIA_STOCK = '3',
  /**
   * 墨西哥股票
   **/
  MEXICO_STOCK = '1',
  /**
   * 美国股票
   **/
  US_STOCKS = '2',
  /**
   * 外汇
   **/
  FOREIGN_EXCHANGE = '6',
  /**
   * 加密货币
   **/
  CRYPTOCURRENCY = '7',
  /**
   * 自选
   **/
  OPTIONAL = '4',

  /**
   * 加密货币 合约
   **/
  CONTRACT = '1',
  /**
   * 股票合约
   **/
  STOCKS_CONTRACT = '8',
}

/**
 * 客服类型
 **/
export enum CustomerServiceTypeEnum {
  /**
   * 银行卡
   **/
  BANK_CARD = 0,
  /**
   * 虚拟币-回调自动充值
   **/
  CRYPTOCURRENCY_AUTO_CALLBACK = 1,
  /**
   * 后台充值
   **/
  BACKGROUND_RECHARGE = 2,
  /**
   * C2C
   **/
  C2C_CUSTOMER_SERVICE = 3,
  /**
   * 虚拟币-上传截图审核
   **/
  CRYPTOCURRENCY_UPLOAD_SCREENSHOT = 4,
  /**
   * 普通客服
   **/
  COMMON_CUSTOMER_SERVICE = 5,
  /**
   * 三方客服
   **/
  THIRD_PARTY_CUSTOMER_SERVICE = 6,
  /**
   * 临时客服
   **/
  TEMPORARY_CUSTOMER_SERVICE = 7,
}
/**
 * 充值通道类型
 **/
export enum RechargeChannelTypeEnum {
  /**
   * 银行卡充值
   **/
  BANK_CARD = 0,
  /**
   * 虚拟币自动回调
   **/
  CRYPTOCURRENCY_AUTO_CALLBACK = 1,
  /**
   * C2C商家买币
   **/
  C2C_BUY = 3,
  /**
   * 虚拟币上传截图
   **/
  CRYPTOCURRENCY_UPLOAD_SCREENSHOT = 4,
}
/**
 * 客服类型
 **/
export enum CustomerServiceRoleEnum {
  /**
   * 客服指定权限
   **/
  CUSTOMER_SERVICE_DESIGNATED_PERMISSIONS = 0,
  /**
   * 拥有者
   **/
  OWNER = 1,
  /**
   * 管理员
   **/
  ADMIN = 2,
  /**
   * 成员
   **/
  MEMBER = 3,
}
/**
 * 钱包类型
 **/
export enum WalletTypeEnum {
  /**
   * 币币
   **/
  COIN = 1,
  /**
   * 合约
   **/
  CONTRACT = 2,
  /**
   * 法币
   **/
  FIAT = 3,
  /**
   * 基金
   **/
  FUND = 4,
}

/**
 * 订单分类
 **/
export enum OrderCategoryEnum {
  /**
   * 币币
   **/
  COIN = 1,
  /**
   * 合约
   **/
  CONTRACT = 2,
  /**
   * 股票
   **/
  STOCK = 3,
  /**
   * 基金
   **/
  FUND = 4,
}

/**
 * 资金记录-可用余额/冻结余额筛选
 **/
export enum FundsRecordTypeOnlyEnum {
  /**
   * 可用余额
   **/
  AVAILABLE_BALANCE = '1',
  /**
   * 冻结余额
   **/
  FROZEN_BALANCE = '2',
}

/**
 * 资金记录-可用余额/冻结余额筛选
 **/
export enum FundsRecordTypeEnum {
  /**
   * 可用余额增加
   **/
  AVAILABLE_BALANCE_INCREASE = '1',
  /**
   * 可用余额减少
   **/
  AVAILABLE_BALANCE_DECREASE = '2',
  /**
   * 冻结余额增加
   **/
  FROZEN_BALANCE_INCREASE = '3',
  /**
   * 冻结余额减少
   **/
  FROZEN_BALANCE_DECREASE = '4',
}
